import styled, { css } from 'styled-components';
import { theme, palette } from 'styled-tools';
import listStyleCircleImage from 'assets/img/common/ic_ok_blue.svg';
import listStyleXImage from 'assets/img/common/ic_warning_red.svg';

export const ContentsContainer = styled.div`
`;

export const ProfileExampleWrapper = styled.div`
    ${theme('commonTopBottomPadding')}
    display: flex;
    justify-content: center;
`;

interface ProfileGuideProps {
  padding?: string;
}

export const ProfileGuideWrapper = styled.div<ProfileGuideProps>`
    ${(props) => props.padding
        ? css`padding: ${props.padding};`
        : css`${theme('commonTopBottomPadding')}`
    }
    ${theme('fontStyle.body2')}
    color: ${palette('gray_opacity_800')};
`;

interface InformationListProps {
  margin?: string;
  hasNotFirstLastChildPadding?: boolean;
  listStyleImageType?: 'circle' | 'x';  // NOTE: default is 'x'
  itemPadding?: string;
}

export const InformationList = styled.ul<InformationListProps>`
    list-style-type: none;
    list-style-image: ${(props) => props.listStyleImageType === 'circle'
        ? css`url(${listStyleCircleImage})`
        : css`url(${listStyleXImage})`
    };
    padding-left: 20px;
    ${(props) => props.margin
        ? css`margin: ${props.margin};`
        : css`margin: 8px 0;`
    }

    & > * {
        &:first-child, &:last-child {
            ${(props) => props.hasNotFirstLastChildPadding
                ? css`padding: 0px 0px 0px 17px;`
                : null
            }
        }
    }

    & > li {
        ${(props) => props.itemPadding
            ? css`padding: ${props.itemPadding};`
            : css`padding: 18px 0px 0px 17px;`
        }
    }
`;

interface InformationItemProps {
  padding?: string;
}

export const InformationItem = styled.li<InformationItemProps>`
    ${theme('fontStyle.body2')}
    align-items: center;
    ${(props) => props.padding
      ? css`padding: ${props.padding};`
      : css`padding: 9px 0;`
    }

    /* padding-left: 17px; */
`;

export const LabelContainer = styled.div`
    ${theme('commonTopBottomPadding')}
`;